// Main entry point for the plugin's frontend scripts
import '../styles/main.scss';

// Import modules
import { initTracking } from './modules/tracking';

document.addEventListener('DOMContentLoaded', () => {
    initTracking();
});
